import React from 'react';

import withApplicationPreferences from '../decorators/withApplicationPreferences';
import QuizSizeQuestion from '../components/QuizSizeQuestion';

const INPUT_NAME = 'size_preferences_attributes';

function QuizSizeQuestionContainer(props) {
  return <QuizSizeQuestion {...props} />;
}

export default withApplicationPreferences(INPUT_NAME)(
  QuizSizeQuestionContainer
);
